<template>
  <div :data-type="item.detailType"
    :style="itemStyle.itemLayout"
    :class="{noFrame: item.detailPadding === '1'}">
    <button
      type="button"
      class="btnClose"
      @click="goList"
      @touchstart.stop="stopSwiper"
      @touchmove.stop="stopSwiper"
      @touchend.stop="stopSwiper">
    </button>
    <div class="left">
      <div v-if="detailType === 'horisontal' && itemStyle.name" class="name" :style="itemStyle.name">
        <pre>{{ item.collectionItemName[lang] }}</pre>
      </div>
      <div class="img" :style="itemStyle.img">
        <img :src="getItemThumb()" alt="" @click="setDetailGallery">
        <button v-if="isCollectableUser && collectionIcon"
          type="button"
          class="btnCollection"
          @click.stop="toggleCollection">
          <img :src="isMyCollection ? collectionIcon.active : collectionIcon.default" alt="" :style="{width: collectionIcon.size}">
        </button>
        <div v-if="imgIndicator" class="imgIndicator">
          <span
            v-for="img in imgIndicator.length"
            :key="img"
            class="dot"
            :style="{backgroundColor: imgIndicator.color}"></span>
        </div>
      </div>
    </div>
    <div class="right" :style="{paddingLeft: itemStyle.img && '50px'}">
      <div v-if="detailType === 'vertical' && itemStyle.name" :style="itemStyle.name" class="name">
        <pre>{{ item.collectionItemName[lang] }}</pre>
      </div>
      <div v-if="itemStyle.descTop" class="descTop" :style="itemStyle.descTop">
        <pre>{{ item.descTop[lang] }}</pre>
      </div>
      <div v-if="itemStyle.descBottom" class="descBottom" :style="itemStyle.descBottom">
        <pre>{{ item.descBottom[lang] }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollectionItemDetail',
  props: [
    'locale',
    'lang',
    'categoryId',
    'collectionItemId',
    'isCollectableUser'
  ],
  computed: {
    pageId () {
      return this.$route.params.pageId
    },
    isMyCollection () {
      return this.$store.getters['collection/getIsMyCollectionItem'](this.collectionItemId)
    },
    getPointColor () {
      return this.$store.getters['collection/getPointColor']
    },
    getCategoryById () {
      return this.$store.getters['collection/getCategoryById'](this.categoryId)
    },
    collectionIcon () {
      const setting = this.getCategoryById && this.getCategoryById.categorySetting
      const useCollection = setting && setting.useCollection
      const myCollectionSetting = this.$store.getters['collection/getMyCollectionSetting']
      const scrapIcon = myCollectionSetting && {
        ...myCollectionSetting.scrapIcon,
        size: `${myCollectionSetting.scrapIcon.size}px`
      }
      return useCollection && scrapIcon
    },
    getItemByItemId () {
      return this.$store.getters['collection/getItemByItemId'](this.collectionItemId)
    },
    item () {
      const item = this.getItemByItemId
      return {
        collectionItemName: item.collectionItemName,
        ...item.attribute
      }
    },
    itemStyle () {
      const item = this.item
      const img = item && item.display.includes('image') && this.getRelativeHeight(item.detailImageRatio.width, item.detailImageRatio.height)
      const name = item && item.display.includes('name') && item.fontSize.collectionItemName
      const descTop = item && item.display.includes('descTop') && item.fontSize.descTop
      const descBottom = item && item.display.includes('descBottom') && item.fontSize.descBottom
      const spacing = this.$store.getters['collection/getCommonItemStyle']
      return {
        itemLayout: {
          gridTemplateColumns: item.detailRatio.map(x => `${x}fr`).join(' '),
          backgroundColor: item.detailColorActive ? item.detailBackgroundColor : '',
          color: item.detailColorActive ? item.detailTextColor : '',
          padding: `${(parseInt(item.detailPadding) - 1) * 20}px`
        },
        ...img && {img: {
          paddingBottom: `${img}%`
        }},
        ...name && {name: {
          fontSize: `${name}px`,
          ...spacing && spacing.name && {
            letterSpacing: spacing.name
          }
        }},
        ...descTop && {descTop: {
          fontSize: `${descTop}px`,
          ...spacing && spacing.descTop && {
            letterSpacing: spacing.descTop
          }
        }},
        ...descBottom && {descBottom: {
          fontSize: `${descBottom}px`,
          ...spacing && spacing.descBottom && {
            letterSpacing: spacing.descBottom
          }
        }}
      }
    },
    detailType () {
      return this.item.detailType
    },
    imgIndicator () {
      return this.item.imageList && this.item.imageList.length > 1 ? {
        length: this.item.imageList.length,
        color: this.getPointColor
      } : null
    }
  },
  methods: {
    getItemThumb () {
      return this.item && this.item.imageList && this.item.imageList[0]
    },
    // 이미지 비율 구하기
    getRelativeHeight (widthStr, heightStr) {
      const width = parseFloat(widthStr)
      const height = parseFloat(heightStr)

      if (!width || !height) {
        return 64 // 그냥 기본 64%
      }

      const ratio = (height / width) * 100
      return ratio // 세로 비율 (단위: %)
    },
    setDetailGallery () {
      this.$store.commit('collection/setDetailGallery', this.collectionItemId)
    },
    goList () {
      this.$router.push({
        name: 'collectionPage',
        params: {
          ln: this.$route.params.ln,
          pageId: this.$route.params.pageId,
          categoryId: this.$route.params.categoryId
        }
      })
    },
    stopSwiper (e) {
      e.stopPropagation()
    },
    async toggleCollection () {
      const func = this.isMyCollection ? 'collection/removeMyCollectionItem' : 'collection/addCollection'
      const collectionCategory = this.getCategoryById.categorySetting.collectionCategory
      const data = {
        pageId: this.pageId,
        collectionCategory: collectionCategory,
        categoryId: this.categoryId,
        ...this.isMyCollection && this.$route.name === 'myCollection' && this.orderItemId ? {
          orderItemId: this.getItemByItemId.orderItemId
        } : {
          collectionItemId: this.collectionItemId
        }
      }
      this.$store.commit('loading', true)
      const res = await this.$store.dispatch(func, data)
      if (this.isMyCollection) {
        if (res && res.status === 200) {
          this.$store.commit('collection/setToastMessage', '내 콜렉션에서 삭제되었습니다.')
        }
      } else {
        if (res && res.result && res.result.orderUUID) {
          this.$store.commit('collection/setToastMessage', '내 콜렉션에 추가되었습니다.')
        }
      }
      this.$store.dispatch('collection/getMyCollectionItems', { pageId: this.pageId })
      this.$store.commit('loading', false)
    }
  }
}
</script>